import { render, staticRenderFns } from "./SalaryDataTable.vue?vue&type=template&id=2a45fe50&"
import script from "./SalaryDataTable.vue?vue&type=script&lang=ts&"
export * from "./SalaryDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports